<template>
    <div class="TicketSystem">
		<div class="row preFilterBlk">
			<div  class="">
				<div v-if="!bIsEdit">
					<div class="filter-tag-row"><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/><span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Заявок найдено: {{ this.masApi_total }}</span></div> 
				</div>
			</div>
			
			<div class="px-3 d-inline-flex flex-wrap"  v-if="!bIsEdit">
				<div class="pr-3"  v-if="!bIsEdit && (this.$GVO.my_profile.Support == 1 || this.$GVO.my_profile.adm == 1)">
					<button class="btn btn-simple btn-primary" @click="goToFAQ()">Настроить FAQ</button>
				</div>
				<button class="btn btn-simple btn-primary" @click="AddTicket()">Добавить заявку</button>
			</div>
			
			<div v-if="bIsEdit"  class="col-12">
				<div class="clientPage bntGroup">
					<base-button @click="GoToEdit(false)" type="primary" class="no-border" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
				</div>
				<ReCardTicketAdd  />
			</div>
		</div>
		<div class="row">
			<div class="col-lg-8 mt-2"  v-show="bShowFilter">
				<ReFilter
				:masAllFilterParams="masAllFilterParams"
				v-model="objGetParams"
				v-on:filterapply="OnFilterApply"
				name="TicketSystem"/>
			</div>
		</div>

		 <card class="mt-3" v-if="!bIsEdit && (this.$GVO.my_profile.Support == 1 || this.$GVO.my_profile.adm == 1)">
			<div >
				<h5><i class="tim-icons icon-send text-success mr-3"></i>Выполнить операцию для одной заявки или группы</h5>
			</div>
			
			<div class="row mx-0 align-items-center mb-3">
				<div class="tStatus-select mr-3">
					<el-select
						class="col-md px-0 select-primary"
						v-model="status_value" 
						clearable
						filterable
						placeholder="Назначьте статус заявки"
						size="large"
					>
						<el-option
							class="select-primary"
							v-for="status in masTicketStatus"
							:key="status.value"
							:label="status.label"
							:value="status.value"
						>
						</el-option>
					</el-select>
				</div>
				<base-button type="success" class="groupfloor" simple @click="StartChange()" v-if="this.$GVO.my_profile.Support == 1 || this.$GVO.my_profile.adm == 1">Применить</base-button>
					
			</div>
		</card>

		 <!-- <card class="mt-3" v-if="!bIsEdit">
			<div >
				<h5><i class="tim-icons icon-bulb-63 text-success mr-3"></i>Часто задаваемые вопросы</h5>
			</div>
			
			<div class="row mx-0 align-items-center mb-3">
				<div class="tStatus-select mr-3">
					<el-select
						class="col-md px-0 select-primary"
						v-model="topic_value" 
						clearable
						placeholder="Выбрать тему заявки"
						size="large"
						@change="filterFAQ()"
					>
						<el-option
							class="select-primary"
							v-for="tg in masTopicTags"
							:key="tg.value"
							:label="tg.label"
							:value="tg.id"
							
						>
						</el-option>
					</el-select>
				</div>
					
			</div>
			<div v-if="this.objFAQ && this.objFAQ.length > 0" class="">
				<template v-for="faq in objFAQ">
					<ReCardTicketFaq :objFAQ="faq" />
				</template>
			</div>
		</card> -->

		
		<ReCardTicketFaqNest :bIsEdit="bIsEdit" />
		
		 
		<card
			v-if="!bIsEdit"
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"	
			class="mt-3">
			<el-table 
				:data="ApiData" 
				style="width: 100%;"
				@row-click="GoToTicket" 
				ref="multipleTable" 
				@selection-change="handleSelectionChange"
				:row-class-name="tableRowClassName"
				@sort-change="onSortChange"
			>

			<el-table-column
				type="selection"
				width="55"
				v-if="this.$GVO.my_profile.Support == 1 || this.$GVO.my_profile.adm == 1"
				>
			</el-table-column>

			<el-table-column
				label="Статус"
				property="status"
				width="120"
			>
				<template v-slot="scope">
					<!-- <span 
					class="badge badge-primary ml-1" 
					 >{{ scope.row.status }}</span> -->
					<template v-for="status in masTicketStatus" >
						<span v-if="scope.row.status == status.value" :key="status.id" 
						:class="[{'badge-warning':scope.row.status == 'new'}, 
						{'badge-primary':scope.row.status == 'open'},
						{'badge-success':scope.row.status == 'solved'},
						{'badge-default':scope.row.status == 'closed'},
						{'badge-info':scope.row.status == 'pending'},]" 
						class="badge ml-1"
						>{{status.label}}</span>	
					</template>
				</template>
			</el-table-column>

			<el-table-column
				label="id"
				property="ticket_id"
				width="60"
			>
			</el-table-column>

			<el-table-column
				label="Заголовок"
				property="name"
				width="260"
			>
			</el-table-column>

			<el-table-column 
				min-width="180"
				label="Автор заявки"
				property="author_name"
			>
				<template v-slot="scope">
					<router-link class="nav-item" tag="a" :to="'/data/staff/id/'+scope.row.author_id">{{scope.row.author_name}}</router-link>
				</template>
			</el-table-column>

			<el-table-column 
				min-width="140"
				label="Тип"
				property="type"
			>
				<template v-slot="scope">
					<span v-for="ttype in masTicketType" :key="ttype.id">
						<span v-if="scope.row.type == ttype.value">{{ttype.label}}</span>	
					</span>
				</template>
			</el-table-column>
			<el-table-column 
				min-width="140"
				label="Приоритет"
				property="priority"
			>
				<template v-slot="scope">
					<span v-for="priority in masTicketPriority" :key="priority.id"
					:class="[{'text-danger':scope.row.priority == 'important'},]">
						<span v-if="scope.row.priority == priority.value">{{priority.label}}</span>	
					</span>
				</template>
			</el-table-column>
			<el-table-column 
				min-width="180"
				label="Время создания"
				property="InsertTime"
				sortable
			>
				<template v-slot="scope" >
					{{ $GVO.convertDateTimeFromMysql(scope.row.InsertTime) }}
				</template>
			</el-table-column>
			<el-table-column 
				min-width="180"
				label="Время обновления тикета"
				property="last_upd_dt"
				sortable
			>
				<template v-slot="scope" >
					<span v-if="scope.row.last_upd_dt != '0000-00-00 00:00:00'">{{ $GVO.convertDateTimeFromMysql(scope.row.last_upd_dt) }}</span>
				</template>
			</el-table-column>
			<el-table-column 
				min-width="180"
				label="Последнее сообщение"
				property="last_upd_by_fio"
			>
				<template v-slot="scope">
					<router-link class="nav-item" tag="a" :to="'/data/staff/id/'+scope.row.last_upd_by_id">{{scope.row.last_upd_by_fio}}</router-link>
				</template>
			</el-table-column>
			<el-table-column 
				min-width="180"
				label="Тема заявки"
				property="topicTag"
			>
				<template v-slot="scope" >
					<span v-for="tg in masTopicTags" :key="tg.id">
						<span v-if="scope.row.topicTag == tg.id"  class="el-tag el-tag--small el-tag el-tag--primary mr-2">{{tg.value}}</span>	
					</span>
				</template>
			
			</el-table-column>
			
			</el-table>
			<!-- <Pagination class="mt-3" :class="[{'': parseInt(masApi_total) > 0}, {'d-none': parseInt(masApi_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masApi_total)*parseInt(count2page)" 
				:perPage="parseInt(count2page)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination> -->
			<Pagination class="mt-3" :class="[{'': parseInt(masApi_total) > 0}, {'d-none': parseInt(masApi_total) < 1}]"
				:type="'info'" 
				:total="parseInt(masApi_total)" 
				:perPage="parseInt(10)"
				:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
				:pClick="pClick">
			</Pagination>
		</card>
		
	</div>
</template>

<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
// import { BaseSwitch } from 'src/components/index';
// import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
import Pagination from 'src/our_components/RePagination';
// import ReActionBtns from 'src/our_components/ReActionBtns.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReCardTicketAdd from 'src/our_components/ReCardTicketAdd.vue';
// import ReCardTicketFaq from 'src/our_components/ReCardTicketFaq.vue';
import ReCardTicketFaqNest from 'src/our_components/ReCardTicketFaqNest.vue';


export default {
	name: 'TicketSystem-page',
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		// BaseSwitch,
        // ReFormPrinter,
        Pagination,
		// ReActionBtns,
		ReFilter,
		ReFilterBtn,
		ReCardTicketAdd,
		// ReCardTicketFaq,
		ReCardTicketFaqNest,
	},
	data() {
		return {
			ApiData: [],
			masAllFilterParams: this.currentFilterConfig(),
			objGetParams:{},
			masApi_total: 0,
			count2page: 10,
			masActions:[],	
			fullscreenLoading: false,
			bShowFilter: false,
			bIsEdit: false,
			masTopicTags: [],
			masTicketStatus: [],
			masTicketType: [],
			masTicketPriority: [],
			status_value: '',
			masTableSelection: [],
			// objFAQ: [],
			// masFAQ_total: 0,
			// topic_value: '',
			objSortLoc: {sortProp: 'ticket_id', sortOrder: 'descending'},  //objSort:{prop: 'lastUpdateDate', order: 'descending'},
		};
	},
	watch: {
		$route(/*to, from*/) {
			if(location.pathname.indexOf('/data/ticketsystem/add') != -1){
				this.bIsEdit = true;
			}else{
				if(location.pathname.indexOf('/edit') != -1){
					this.bIsEdit = true;
				}else{
					this.bIsEdit = false;
				}
			}
		}
	},
	computed: {

	},
	methods: {
		getApiData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getApi',this.objGetParams);
				filter = this.objGetParams;
			}

			this.$GVO.ApiCall('TicketSystem.GET',{flt: {...filter} }) /**/
			.then((objApi) => {
				this.masApi_total = 0;
				this.ApiData = [];

				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
						// this.masObjects_total = objApi.total;
						// console.log(objApi);
						if(objApi.total!=undefined) { this.masApi_total=objApi.total; }
					}
				}else{
					this.ApiData = [];
					this.masApi_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masApi_total=0; console.error(errorObjApi);});
		},
		AddTicket(){
			this.$router.push({path: '/data/ticketsystem/add'});
		},
		GoToEdit(){
			//this.bIsEdit = bGo;
			if(location.pathname.indexOf('/data/ticketsystem/add') != -1){
				this.$router.push({path: '/data/ticketsystem'});
			}else{
				this.$router.push({path: '/data/ticketsystem/id/'+this.$route.params.ticket_id});
			}
			
		},
		currentFilterConfig(){
			this.$GVO.ApiCall('GET_FILTER',{obj:'TicketSystem'})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFilterParams = objApi.config;
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			// return require('src/conf/supportFilterConfig.js').support_FilterConfig;
			return [];
		},
		OnFilterApply(data){
			// console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined'){
				delete this.objGetParams['p'];
			}

			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			this.getApiData();
		},	
		GoToTicket(rowData){
			//location.href = `/data/ColdCall/id/${rowData.id}`; 
			this.$router.push({path: `/data/ticketsystem/id/${rowData.ticket_id}`});
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},

		openFullScreen1(){
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 10000);
		},
		StartChange(){
			//console.log(this.masTableSelection);
			if(this.masTableSelection.length>0){
				let masSend = [];
				for (let i = 0; i < this.masTableSelection.length; i++) {
					masSend.push(this.masTableSelection[i].ticket_id);
				}
				// console.log('masSend ' + masSend);
				
				if(this.status_value!=''){
					
					this.$GVO.ApiCall('TicketSystem.SET_STATUS_GROUP',{flt:{ticket_ids: masSend},uData:{
						status:this.status_value, 
						sup_agent_id: this.$GVO.my_profile.code , 
						sup_agent_name: this.$GVO.my_profile.fio,
						// topicTag: this.topicTag,
						// status_changed_by_id: this.$GVO.my_profile.code , 
						// status_changed_by_fio: this.$GVO.my_profile.fio,
						}}) 
					.then((objApi) => {
						// console.log(objApi);
						if(objApi.success === true){
							this.ProcessResult(objApi,this.status_value!=''?this.status_value:false);
							this.getApiData();
						}else{
							alert('Не сохранилось. Возможно у вас нет прав на обработку заявки');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
				}

			}
		},
		ProcessResult(objApi, status_value){
			let bSuccess = true;
			for (let i = 0; i < this.ApiData.length; i++) {
				if(Object.keys(objApi.data).indexOf(this.ApiData[i].id) != -1){
					// if(objApi.data[this.ApiData[i].id].success == true)this.ApiData[i].agent_name = this.agent_model.inputText;
					if(status_value != false){
						for (let x = 0; x < this.status_options.length; x++) {
							if(this.masTicketStatus[x].value == status_value){
								this.ApiData[i].status = this.masTicketStatus[x].value;
							}								
						}
					}
					this.ApiData[i] = {...this.ApiData[i],...{'gop_success':objApi.data[this.ApiData[i].id].success}};
					if(objApi.data[this.ApiData[i].id].success == false) bSuccess = false;
				}
			}
			this.checkTableRows();
			this.$refs.multipleTable.doLayout();
			if(bSuccess){this.$emit("change", true);}

		},
		handleSelectionChange(val) {
			this.masTableSelection = val;
		},
		checkTableRows(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		tableRowClassName({row/*, rowIndex*/}) {
			if (typeof row.gop_success != 'undefined') {
				if(row.gop_success==false){
					return 'table-danger';
				} else if (row.gop_success==true) {
					return 'table-success';
				}
			}
			return '';
		},
		goToFAQ(){
			this.$router.push({path: '/data/ticketsystem/faq'});
		},
		onSortChange(objSort){
			//console.log(objSort);
			this.objSortLoc.sortProp = this.$GVO.unlinkObject(objSort.prop);
			this.objSortLoc.sortOrder = this.$GVO.unlinkObject(objSort.order);

			let bFromObj = false;
			if(SGVO.prevRoute != null) 
				if(SGVO.prevRoute.indexOf('/ticketsystem/id/')>0) bFromObj = true;

			if(objSort.order != null){
				var queryParams = new URLSearchParams(window.location.search);
				queryParams.set("sortProp", objSort.prop);
				queryParams.set("sortOrder", objSort.order);
				history.replaceState(null, null, "?"+queryParams.toString());
				this.objGetParams = this.$GVO.GetAllGet();
				if(typeof this.objGetParams['p'] != 'undefined' && bFromObj===false){
					delete this.objGetParams['p'];
				}
				if(bFromObj===false) this.OnFilterApply();
			}
		}

	},		
	created(){

	},
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		if(typeof this.objGetParams.sortProp != 'undefined'){
			this.objSortLoc.sortProp = this.$GVO.unlinkObject(this.objGetParams.sortProp);
			this.objSortLoc.sortOrder = this.$GVO.unlinkObject(this.objGetParams.sortOrder);
			this.$refs.multipleTable.sort(this.objSortLoc.sortProp,this.objSortLoc.sortOrder);
		}

		// if(typeof this.$GVO.cats.CAT_TICKET_TAGS != 'undefined'){}
			this.$GVO.LoadCatPromise('CAT_TICKET_TAGS')
			.then((objApi) => {
				if(objApi=== true){
					for (let i = 0; i < this.$GVO.cats.CAT_TICKET_TAGS.length; i++) {
						const element = this.$GVO.cats.CAT_TICKET_TAGS[i];
						if(element.act==1) this.masTopicTags.push({'value':element.val,'label':element.val, 'id':element.id}); //вопрос val или id ?
					}
				}
			})
			.catch(errorObjApi => {console.error(errorObjApi); });
		
		// if(typeof this.$GVO.cats.cat_ticket_status != 'undefined'){}
			this.$GVO.LoadCatPromise('cat_ticket_status')
			.then((objApi) => {
				if(objApi=== true){
					// this.masTopicTags = []
					for (let i = 0; i < this.$GVO.cats.cat_ticket_status.length; i++) {
						const element = this.$GVO.cats.cat_ticket_status[i];
						if(element.act==1) this.masTicketStatus.push({'value':element.value,'label':element.label, 'id':element.id}); //вопрос val или id ?
					}
				}
			})
			.catch(errorObjApi => {console.error(errorObjApi); });
		
		// if(typeof this.$GVO.cats.cat_ticket_type != 'undefined'){}
			this.$GVO.LoadCatPromise('cat_ticket_type')
			.then((objApi) => {
				if(objApi=== true){
					// this.masTopicTags = []
					for (let i = 0; i < this.$GVO.cats.cat_ticket_type.length; i++) {
						const element = this.$GVO.cats.cat_ticket_type[i];
						if(element.act==1) this.masTicketType.push({'value':element.value,'label':element.label, 'id':element.id}); //вопрос val или id ?
					}
				}
			})
			.catch(errorObjApi => {console.error(errorObjApi); });
		
		// if(typeof this.$GVO.cats.cat_ticket_priority != 'undefined'){}
			this.$GVO.LoadCatPromise('cat_ticket_priority')
			.then((objApi) => {
				if(objApi=== true){
					// this.masTopicTags = []
					for (let i = 0; i < this.$GVO.cats.cat_ticket_priority.length; i++) {
						const element = this.$GVO.cats.cat_ticket_priority[i];
						if(element.act==1) this.masTicketPriority.push({'value':element.value,'label':element.label, 'id':element.id}); //вопрос val или id ?
					}
				}
			})
			.catch(errorObjApi => {console.error(errorObjApi); });
		
			// this.getFAQ();
		
		
		// this.getApiData();
	}
};
</script>
<style scoped>

.TicketSystem >>> .el-table tr:hover {cursor: pointer; background: rgb(1, 176, 224, 0.33);}
.TicketSystem >>>  .el-table table {width: 100%!important;}
.TicketSystem >>>  .el-table .cell {word-break: break-word;}
.preFilterBlk{align-items: baseline; margin-top:20px; justify-content: space-between;}

@media (max-width: 576px){
		.preFilterBlk .d-flex {flex-direction: column; margin-bottom: 10px;}
		.filter-tag-row {padding: 0 15px;}
	}

</style>
